import React, { useState } from 'react';

/*
 * Centre line of the Wripple logo (public/images/wripple_logo.png), traced from the
 * artwork. The logo is one continuous closed ribbon, split here into two layers:
 *  FRONT – the visible "W": left loop, peak, valley and right loop
 *  BACK  – the strands that tuck behind it (both tails and the two inner diagonals)
 * The back layer is masked by a slightly wider copy of the front, which leaves the
 * same small transparent gap the logo has wherever the line passes behind itself.
 * Drawing FRONT then BACK traces the whole line once, start to finish.
 */
const FRONT_LINE = 'M97.4,299.8C96.7,294.6 95.8,287.9 94.6,282.1C93.4,276.2 91.8,270.5 90.3,264.7C88.8,258.9 87,253.1 85.5,247.3'
    + 'C84,241.5 82.6,235.7 81.2,229.8C79.9,224 78.7,218.1 77.5,212.3C76.3,206.4 75.2,200.5 74.1,194.6'
    + 'C73,188.7 71.9,182.8 70.8,176.9C69.6,171 68.5,165.1 67.3,159.2C66.1,153.4 65,147.4 63.4,141.7'
    + 'C61.7,136 60.1,129.9 57.3,125.1C54.5,120.4 50.5,115.5 46.4,113.4C42.3,111.3 36.6,110.8 32.7,112.6'
    + 'C28.8,114.3 25.2,119 23,123.7C20.9,128.4 20.3,134.9 19.6,140.7C19,146.5 19.2,152.7 19.3,158.7'
    + 'C19.4,164.7 19.8,170.7 20.3,176.6C20.7,182.6 21.4,188.6 22.2,194.5C23,200.4 24,206.4 25,212.3'
    + 'C26.1,218.2 27.3,224 28.7,229.9C30,235.7 31.5,241.5 33,247.3C34.6,253.1 36.2,258.9 38,264.6'
    + 'C39.8,270.3 41.7,276 43.8,281.6C45.9,287.3 48.1,292.8 50.5,298.3C52.9,303.8 55.4,309.3 58.3,314.5'
    + 'C61.1,319.8 64.1,325 67.6,329.8C71.1,334.6 74.9,339.4 79.3,343.1C83.7,346.8 88.8,350.2 94,351.9'
    + 'C99.2,353.6 105.4,354.2 110.5,353.1C115.6,352 120.7,349 124.6,345.3C128.5,341.5 131.4,336.1 133.8,330.8'
    + 'C136.3,325.6 137.8,319.6 139.4,313.8C141,308.1 142.3,302.2 143.4,296.3C144.6,290.4 145.6,284.5 146.5,278.6'
    + 'C147.5,272.7 148.2,266.7 149,260.8C149.7,254.8 150.3,248.9 151,242.9C151.7,236.9 152.3,231 153,225'
    + 'C153.6,219 154.2,213.1 154.8,207.1C155.4,201.1 156,195.2 156.6,189.2C157.3,183.2 157.9,177.3 158.6,171.3'
    + 'C159.3,165.4 160.1,159.4 160.9,153.5C161.7,147.5 162.5,141.6 163.4,135.6C164.3,129.7 165.2,123.8 166.2,117.9'
    + 'C167.2,112 168.3,106 169.5,100.2C170.8,94.3 172.2,88.5 173.8,82.7C175.4,77 177.1,71.2 179.3,65.6'
    + 'C181.4,60.1 183.7,54.4 186.7,49.4C189.7,44.4 193.2,39.3 197.4,35.5C201.5,31.6 206.6,28.2 211.8,26.5'
    + 'C217,24.8 223.1,24.3 228.4,25.3C233.6,26.2 239.1,29 243.4,32.4C247.8,35.8 251.4,40.8 254.5,45.7'
    + 'C257.6,50.6 259.9,56.3 262.1,61.8C264.3,67.4 266.1,73.1 267.7,78.9C269.4,84.6 270.8,90.5 272.1,96.3'
    + 'C273.4,102.2 274.6,108.1 275.8,113.9C276.9,119.8 278,125.7 279,131.6C280,137.6 280.9,143.5 281.7,149.4'
    + 'C282.6,155.4 283.3,161.3 284,167.3C284.7,173.2 285.4,179.2 286.1,185.1C286.8,191.1 287.5,197.1 288.1,203'
    + 'C288.8,209 289.4,215 290,220.9C290.6,226.9 291.2,232.9 291.8,238.8C292.4,244.8 293,250.8 293.6,256.7'
    + 'C294.2,262.7 294.9,268.7 295.5,274.6C296.1,280.6 296.7,286.6 297.3,292.5C298,298.5 298.6,304.5 299.3,310.4'
    + 'C300,316.4 300.6,322.4 301.4,328.3C302.1,334.3 302.9,340.2 303.7,346.2C304.5,352.1 305.4,358 306.3,364'
    + 'C307.1,369.9 308,375.8 309,381.8C310,387.7 310.9,393.6 312.1,399.5C313.2,405.4 314.5,411.2 315.9,417.1'
    + 'C317.3,422.9 318.8,428.7 320.6,434.4C322.4,440.1 324.2,445.9 326.5,451.3C328.9,456.8 331.4,462.4 334.8,467.1'
    + 'C338.1,471.8 342.2,476.4 346.8,479.4C351.4,482.3 357.1,484.4 362.4,484.8C367.7,485.2 373.7,483.9 378.6,481.5'
    + 'C383.4,479.1 387.8,474.8 391.3,470.4C394.7,466 397.3,460.3 399.5,454.9C401.8,449.4 403.4,443.6 404.9,437.8'
    + 'C406.5,432 407.7,426.1 408.8,420.2C409.9,414.4 410.8,408.4 411.6,402.5C412.4,396.5 413.1,390.6 413.7,384.6'
    + 'C414.3,378.6 414.8,372.7 415.3,366.7C415.8,360.7 416.1,354.7 416.4,348.7C416.8,342.7 417,336.7 417.2,330.8'
    + 'C417.5,324.8 417.8,318.8 418,312.8C418.3,306.8 418.6,300.8 418.8,294.8C419,288.8 419.2,282.8 419.3,276.8'
    + 'C419.5,270.8 419.7,264.8 419.8,258.8C420,252.8 420.1,246.8 420.3,240.8C420.5,234.8 420.8,228.8 421.1,222.9'
    + 'C421.4,216.9 421.8,210.9 422.1,204.9C422.5,198.9 422.9,192.9 423.4,186.9C423.8,181 424.3,175 425,169'
    + 'C425.7,163.1 426.4,157.1 427.5,151.2C428.6,145.3 429.6,139.3 431.4,133.7C433.2,128.1 435.1,122.1 438.2,117.6'
    + 'C441.3,113.1 445.6,108.7 450.1,106.8C454.7,104.9 460.7,104.7 465.3,106.2C470,107.7 474.7,111.7 478.1,116'
    + 'C481.4,120.2 483.6,126.1 485.5,131.6C487.3,137.2 488.3,143.2 489.2,149.1C490.1,155 490.6,161 491,167'
    + 'C491.4,173 491.6,179 491.6,185C491.6,191 491.4,196.9 491.1,202.9C490.8,208.9 490.4,214.9 489.8,220.9'
    + 'C489.3,226.8 488.6,232.8 487.8,238.8C487,244.7 486,250.6 485,256.5C483.9,262.4 482.7,268.3 481.4,274.1'
    + 'C480.1,280 478.7,285.8 477.1,291.6C475.5,297.4 473.7,303.1 472,308.8C470.2,314.6 468.4,320.3 466.7,326';

const BACK_LINE = 'M466.7,326C465.1,331.8 463.6,337.6 462.1,343.4C460.5,349.2 459.3,355.1 457.5,360.8'
    + 'C455.7,366.5 454,372.4 451.2,377.3C448.4,382.3 445,387 440.6,390.3C436.3,393.6 430.7,395.8 425.2,397'
    + 'C419.7,398.2 413.3,398.4 407.7,397.6C402.1,396.8 396.1,395.1 391.5,392.3C386.9,389.5 382.9,385.2 380.1,380.5'
    + 'C377.2,375.8 375.9,369.8 374.4,364.2C372.8,358.5 372.2,352.4 371,346.5C369.8,340.7 368.5,334.8 367,329'
    + 'C365.5,323.2 363.7,317.5 362,311.8C360.3,306 358.6,300.3 357,294.5C355.4,288.7 353.8,282.9 352.3,277.1'
    + 'C350.8,271.3 349.3,265.5 347.8,259.7C346.4,253.9 345,248 343.6,242.2C342.3,236.3 341.1,230.5 340,224.6'
    + 'C338.8,218.7 337.7,212.8 336.6,206.9C335.5,201 334.4,195.1 333.3,189.2C332.1,183.3 331,177.5 329.8,171.6'
    + 'C328.5,165.7 327.2,159.9 325.8,154C324.5,148.2 323,142.4 321.4,136.6C319.8,130.8 318.3,124.9 316.2,119.4'
    + 'C314.1,113.9 312,108.1 308.8,103.4C305.6,98.8 301.6,94.5 297,91.6C292.3,88.7 286.5,86.9 280.9,86.1'
    + 'C275.3,85.2 268.9,85.3 263.4,86.5C257.9,87.6 252.2,89.7 248,93C243.8,96.2 240.6,101 238.3,106'
    + 'C236,111 235.3,117.2 234.4,123C233.5,128.8 233.4,135 232.8,140.9C232.2,146.9 231.7,152.9 231,158.8'
    + 'C230.2,164.8 229.3,170.7 228.4,176.6C227.4,182.5 226.4,188.4 225.5,194.4C224.5,200.3 223.6,206.2 222.5,212.1'
    + 'C221.5,218 220.5,223.9 219.4,229.8C218.3,235.7 217.2,241.6 216,247.5C214.7,253.3 213.5,259.2 211.9,265'
    + 'C210.4,270.8 208.8,276.6 206.8,282.2C204.8,287.8 202.5,293.4 200,298.8C197.4,304.2 194.6,309.5 191.6,314.7'
    + 'C188.7,319.9 185.7,325.2 182.3,330C178.8,334.7 175.2,339.7 170.8,343.2C166.4,346.6 161.2,349.4 155.9,350.6'
    + 'C150.6,351.8 144.5,351.5 138.9,350.4C133.4,349.3 127.5,347 122.6,344.1C117.6,341.2 112.7,336.7 109.2,333.1'
    + 'C105.6,329.5 103.1,325.6 101.4,322.3C99.6,319.1 99.5,317.2 98.8,313.5C98.1,309.7 98.1,305 97.4,299.8';

const LINE_WIDTH = 36;   // keep in sync with .wripple-loader-traced path in _components.less
const GAP = 10;          // transparent gap where the back strands pass behind the front

let instanceCount = 0;

/**
 * The app's loading indicator (used by components/LoadingBanner.js): the full logo
 * ribbon, including the strands that pass behind, draws itself in, holds, then un-draws.
 * WrippleLoader.js is the simpler "W mark" alternative.
 * Animation lives in _components.less (.wripple-loader-traced).
 */
const WrippleLoaderTraced = ({ size = 56, className = '' }) => {
    // Unique ids so several loaders can be on screen at once
    const [id] = useState(() => `wripple-loader-traced-${++instanceCount}`);
    const gapMask = `url(#${id}-gap)`;

    return (
        <svg
            className={`wripple-loader-traced ${className}`}
            width={size}
            height={size}
            viewBox="-4 -4 520 520"
            role="img"
            aria-label="Loading"
        >
            <defs>
                <mask id={`${id}-gap`} maskUnits="userSpaceOnUse" x="-20" y="-20" width="560" height="560">
                    <rect x="-20" y="-20" width="560" height="560" fill="#fff" />
                    <path
                        d={FRONT_LINE}
                        style={{ fill: 'none', stroke: '#000', strokeWidth: LINE_WIDTH + GAP * 2, strokeLinecap: 'butt' }}
                    />
                </mask>
                <linearGradient id={`${id}-fill`} x1="0" y1="0" x2="512" y2="0" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#b07cf7" />
                    <stop offset="0.5" stopColor="#8b3ef0" />
                    <stop offset="1" stopColor="#6d28d9" />
                </linearGradient>
            </defs>

            <g className="wripple-loader-traced__ghost">
                <path d={BACK_LINE} mask={gapMask} />
                <path d={FRONT_LINE} />
            </g>

            <path className="wripple-loader-traced__back" d={BACK_LINE} pathLength="1" stroke={`url(#${id}-fill)`} mask={gapMask} />
            <path className="wripple-loader-traced__front" d={FRONT_LINE} pathLength="1" stroke={`url(#${id}-fill)`} />
        </svg>
    );
};

export default WrippleLoaderTraced;
